const state = {
    screenshotList: [],
    transferEquipmentList: [],
    authorizeObj: {},
    // activationCodeList: []
}
const mutations = {
    SET_SCREENSHOTLIST: (state, arr) => {
        state.screenshotList = arr
    },
    SET_TEANSFEREQUIPMENTLIST: (state, cover) => {
        state.transferEquipmentList = cover
    },
    SET_AUTHORIZEOBJ: (state, cover) => {
        state.authorizeObj = cover
    },
    // SET_ACTIVATIONCODELIST: (state, cover) => {
    //     state.activationCodeList = cover
    // },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}